import script from "./agendaSection.vue?vue&type=script&setup=true&lang=js"
export * from "./agendaSection.vue?vue&type=script&setup=true&lang=js"

import "./agendaSection.vue?vue&type=style&index=0&id=4d81443c&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d81443c"]])

export default __exports__